import * as React from "react";
import Grid from "@material-ui/core/Grid";
import PageHeader from "./pageHeader";
import PageFooter from "./pageFooter";
import {makeStyles} from "@material-ui/styles";


const useStyles = makeStyles(theme => ({

    paperA4: {
        size: "A4",
        width: '210mm',
        height: '297mm',
        border: 0,
        borderStyle: 'solid',
        borderColor: 'red',
        padding: '10mm',
        backgroundColor: 'white'
    },
    paperA4Util: {
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 0,
        borderStyle: 'solid',
        borderColor: 'blue',
        justifyContent: "space-between",
        display: 'flex',
        flexDirection: 'column',
        flexWrap: "nowrap"
    },

    reportBody: {
        width: '100%',
        height: '100%',
        border: 0,
        borderStyle: 'solid',
        borderColor: 'green',
        display: 'flex',
        flexGrow: 0,
        justifyContent: "space-between",
        flexDirection: 'column',
        flexWrap: "nowrap"
    },

    gridAreaCima: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        flexGrow: 0,
        flexWrap: "nowrap",
        marginBottom: theme.spacing(1) * 2,
        border: 0,
        borderStyle: 'solid',
        borderColor: 'yellow'
    },

    gridAreaBaixo: {
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        flexWrap: "nowrap",
        justifyContent: 'flex-end',
        border: 0,
        borderStyle: 'solid',
        borderColor: 'blue',
        flexGrow: 0,
    },


}));

const PaginaA4 = (props) => {
    const classes = useStyles();
    const {titulo, subtitulo, areaCima, areaBaixo, pagina, rodape} = props;

    return (
        <Grid container id={'paperA4'} className={classes.paperA4} >
            <Grid container id={'paperA4Util'} className={classes.paperA4Util} >
                <PageHeader id={'pageHeader'} titulo={titulo} subtitulo={subtitulo}/>
                <Grid container id={'reportBody'} className={classes.reportBody}>
                    <Grid container item  id={'gridAreaCima'} className={classes.gridAreaCima}>
                        {areaCima}
                    </Grid>
                    <Grid container item id={'gridAreaBaixo'}  className={classes.gridAreaBaixo}>
                        {areaBaixo}
                    </Grid>
                </Grid>
                <PageFooter id={'pageFooter'} pagina={pagina} meio1 ={rodape}/>
            </Grid>
        </Grid>
    )
}


export default  PaginaA4;